import React from 'react'
import { Link } from 'react-router-dom'
import { Page_settings } from '../../config/page_settings'
import strings from '../../lang/strings'

const Footer = (props) => {
  return (
    <Page_settings.Consumer>
      {({ }) => (
        <div id='footer' className='footer'>
          <div className='nav-footer'>
            <div className='nav-footer-logo sm-fs-12'>
              <Link to='/dashboard' className='footer-logo'>
                <img className='logo' src={'/assets/image/logo.png'} alt='' />
              </Link>
              <div className='mt-12'>{strings.app_name}<span className='dash'>|</span>{strings.ceo}<span className='dash'>|</span>{strings.bus_no}<span className='dash'>|</span>{strings.app_address}</div>
              <div className=''>{strings.app_tel}<span className='dash'>|</span><span>{strings.app_email}</span></div>
              <div className=''>{strings.app_mailno}</div>
              <div className='copyright'>{strings.app_footer}</div>
            </div>
            <div className='footer-link'>
              <div className='f-sb'>{strings.go}</div>
              <Link to='/dashboard'>
                <div className='mt-10'>{strings.home}</div>
              </Link>
              {/* <Link to='/analyst/list'>
                <div>{strings.analyst_member}</div>
              </Link> */}
            </div>
            <div className='footer-link'>
              <div className='f-sb'>{strings.info}</div>
              <Link to={{ pathname: '/cs', state: { tabIndex: 2} }}>
                <div className='mt-10'>{strings.po_terms}</div>
              </Link>
              <Link to={{ pathname: '/cs', state: { tabIndex: 3} }}>
                <div>{strings.po_privacy}</div>
              </Link>
              <Link to={{ pathname: '/cs', state: { tabIndex: 5} }}>
                <div>{strings.po_refund}</div>
              </Link>
            </div>
            <div className='footer-link'>
              <div className='f-sb'>{strings.cs_center}</div>
              <a className='connect-kakao' href={strings.kakaoOpenLink} target="_blank" rel="noopener noreferrer">
                <div className='mt-10'>{strings.kakaoCs}</div>
              </a>
              <div>
                <div style={{color : "#ffffffb3", whiteSpace: 'pre-line'}}>{strings.kakaoCsOperatingTime}</div>
              </div>
            </div>
            {/* <div className='footer-link'>
              <div className='f-sb'>{strings.intro}</div>
              <Link to={{ pathname: '/cs', state: { tabIndex: 6} }}>
                <div className='mt-20'>{strings.po_company}</div>
              </Link>
              <Link to={{ pathname: '/cs', state: { tabIndex: 0} }}>
                <div>{strings.cs_center}</div>
              </Link>
            </div> */}
          </div>
        </div>
      )}
    </Page_settings.Consumer>
  )
}

export default Footer
